import React from "react";
import { Col, Row, Typography } from "antd";
import { FaCalendarAlt } from "react-icons/fa";
import FadeInImage from "../Images/FadeInImage";
import dayjs from "dayjs";
import { KEYS } from "../../Config/Keys";
import { useLocation, useNavigate } from "react-router-dom";

const PastEventCard = ({ data }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const currentUser = pathname.includes("player") ? "player" : "organizer";
  const eid = data?._id || 123;
  return (
    <Row
      className="sideItem"
      style={{ cursor: "pointer" }}
      onClick={() => {
        if (currentUser === "player") {
          navigate(`/view/event/${eid}/timeline`, { state: "event" });
        } else if (currentUser === "organizer") {
          navigate(`/${currentUser}/event/${eid}/timeline`, { state: "event" });
        }
      }}>
      <FadeInImage
        radiusAll
        type={"FadesideItem"}
        src={
          data?.file?.fileUrl ? KEYS.API + data?.file?.fileUrl : KEYS.API + data?.eventFile?.fileUrl
        }
        className="sideImageHeight"
        fallaback="/images/subevent.png"
      />
      <Col lg={24} md={24} xs={24} sm={24}>
        <div style={{ padding: "0px 20px" }}>
          <p
            style={{
              fontSize: "11px",
              marginTop: "10px",
              marginBottom: "2px",
              fontWeight: "500"
            }}>
            {data?.name || data?.eventName || "-"}
          </p>
          <p className="bold mb-1">
            <span>{data?.numberOfParticipants}</span> Participants
          </p>
          <p style={{ fontSize: "11px", marginTop: "10px" }}>
            <FaCalendarAlt />{" "}
            {data?.startDate ? dayjs(data?.startDate).format("DD MMM YYYY") : "- no date"}
          </p>
          <p
            style={{
              fontSize: "11px",
              marginTop: "10px",
              color: "#0085FF"
            }}>
            Panel:{" "}
            <Typography.Text type="secondary">{data?.panel?.name || data?.panel}</Typography.Text>
          </p>
        </div>
      </Col>
    </Row>
  );
};

export default PastEventCard;
